import { useMemo } from "react";

import { OutcomeAssessmentTable } from "./OutcomeAssessmentTable";

import { useFetchAndSelectMyAssessmentsInOrg } from "components/materials/section/assessment/assessment-data";
import { t } from "i18n/i18n";
import { useAppSelector } from "store/index";
import {
  NestedSectionOutcomeType,
  selectCurrentSectionId,
  selectPagesWithAssessmentsForOutcomeAndUser,
} from "store/selectors";
import { useListSelector } from "store/store-hooks";

/**
 * Displays assessment data from other sections for the given outcome,
 * filtered to exclude the current course.
 */
// TODO: This component loads its data in rather inefficient manner.  It loads all the data from all it's sections
// one course at a time.  We really should just have make one query that returns the summarized data we need for all sections.
export const StudentOtherSectionOutcomeUseIndex = ({
  sectionOutcome,
}: {
  sectionOutcome: NestedSectionOutcomeType;
}) => {
  const currentSectionId = useAppSelector(selectCurrentSectionId);
  const allPagesWithAssessments = useListSelector((s) =>
    selectPagesWithAssessmentsForOutcomeAndUser(s, sectionOutcome.outcome_id),
  );

  const otherSectionPages = useMemo(() => {
    if (!currentSectionId) return [];
    return allPagesWithAssessments.filter((page) => page.section_id !== currentSectionId);
  }, [allPagesWithAssessments, currentSectionId]);

  useFetchAndSelectMyAssessmentsInOrg();

  if (!otherSectionPages.length) return null;

  return (
    <OutcomeAssessmentTable
      data={otherSectionPages}
      title={t("assessment_dashboard.student_outcome_page_list.other_title")}
      showSectionColumn
    />
  );
};
